import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Stack,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@mui/material";
import ButtonComponent from "../../../components/atoms/ButtonComponent";
import useShifts from "../../../hooks/useShifts";
import AlertComponent from "../../../components/atoms/Alert";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "8px",
  p: 4,
  width: "80%",
  maxHeight: "90vh",
  overflowY: "auto",
};

function ModalCampaigns({
  open = false,
  handleClose = () => {},
  fileName = "",
  setFileName = () => {},
  rowsTable = [],
  columnsTable = [],
  file = null,
  setFile = () => {},
  fetchDataAndUpdateTable = () => {},
}) {
  const { id } = useParams();
  const { importShiftUsers, loader } = useShifts();
  const [tableData, setTableData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [typeAlert, setTypeAlert] = useState("success");

  useEffect(() => {
   
    createColumsForTable();
  }, [columnsTable, rowsTable]);

  useEffect(() => {
    let timeout;
    if (showAlert && typeAlert === "success") {
      timeout = setTimeout(() => {
        setShowAlert(false);
        handleClose();
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [showAlert]);

  const sendFile = async () => {
   

    if (!file) {
      setMessageAlert("No hay archivo seleccionado");
      setTypeAlert("error");
      setShowAlert(true);
      return;
    }

    try {
      const response = await importShiftUsers(file, id);
      

      if (response?.success === true) {
        setMessageAlert(response.message || "Turnos importados con éxito");
        setTypeAlert("success");
        setShowAlert(true);
        
        // Limpiar estado en el padre
        if (typeof setFileName === "function") setFileName("");
        if (typeof setFile === "function") setFile(null);
        
        if (fetchDataAndUpdateTable) {
          fetchDataAndUpdateTable(id);
        }
      } else {
        setMessageAlert(response?.message || "Error al importar turnos");
        setTypeAlert("error");
        setShowAlert(true);
      }
    } catch (err) {
      console.error("Error en sendFile:", err);
      setMessageAlert("Error inesperado al procesar el archivo");
      setTypeAlert("error");
      setShowAlert(true);
    }
  };

  const createColumsForTable = () => {
    const limit = Math.min(rowsTable.length, 10);
    const newArray = rowsTable.slice(0, limit);
    setTableData(newArray);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Stack sx={style}>
        {showAlert && (
          <AlertComponent
            message={messageAlert}
            handleClose={() => setShowAlert(false)}
            typeAlert={typeAlert}
          />
        )}
        
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
          Previsualización de Importación: {fileName}
        </Typography>

        <TableContainer sx={{ maxHeight: '400px', mb: 2 }}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                {columnsTable.map((item, index) => (
                  <TableCell
                    sx={{
                      fontFamily: "Raleway, sans-serif",
                      fontSize: "0.9rem",
                      fontWeight: "bold",
                      backgroundColor: "#f5f5f5"
                    }}
                    key={index}
                    align="center"
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {tableData.map((rowsItem, index) => (
                <TableRow key={`row-${index}`}>
                  {rowsItem.map((itemColumn, subIndex) => (
                    <TableCell
                      sx={{
                        fontFamily: "Raleway, sans-serif",
                        fontSize: "0.85rem",
                      }}
                      key={`column-${index}-${subIndex}`}
                      align="center"
                    >
                      {itemColumn}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "center",
            gap: 2,
            marginTop: "10px",
          }}
        >
          <ButtonComponent
            label="Cancelar"
            onClick={handleClose}
            backgroundColor="#9a2edb"
            color="white"
            width="30%"
          />
          <ButtonComponent
            label={loader ? "Enviando..." : "Confirmar e Importar"}
            backgroundColor="#1976d2"
            onClick={sendFile}
            disabled={loader}
            width="30%"
          />
        </Stack>
      </Stack>
    </Modal>
  );
}

export default ModalCampaigns;
